{
  "slug": "iq-test-vs-mensa-test",
  "title": "IQ Test vs Mensa Admission Test",
  "description": "A broad battery describes a profile; admission testing determines whether an accepted score meets an organization’s threshold.",
  "category": "Comparisons",
  "sections": [
    {
      "heading": "Purpose",
      "paragraphs": [
        "A broad battery describes a profile; admission testing determines whether an accepted score meets an organization’s threshold.",
        "Begin with purpose rather than asking which score is universally better."
      ]
    },
    {
      "heading": "Measurement differences",
      "paragraphs": [
        "Compare content, limits, norms, reliability, validity, preparation, and decision rules.",
        "Correlation does not make measures interchangeable."
      ]
    },
    {
      "heading": "What to use",
      "paragraphs": [
        "Use evidence validated for the question. Admissions, clinical evaluation, grades, creativity, and emotion need different evidence.",
        "Do not convert scores without a justified publisher method."
      ]
    }
  ],
  "related": ["iq-vs-intelligence", "iq-vs-eq", "how-is-iq-measured"],
  "sources": [],
  "faqs": [],
  "summary": "A broad battery describes a profile; admission testing determines whether an accepted score meets an organization’s threshold. Content reviewed 18 July 2026."
}
